var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIconHeading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9622 0.624844C10.9622 0.279844 10.6823 0 10.3373 0H0.624844C0.279844 0 0 0.279844 0 0.624844V15L5.48109 12.4373L10.9622 15V0.624844ZM8.16234 10.1686L5.48109 8.74969L2.79984 10.1686L3.31219 7.18734L1.14328 5.07469L4.14328 4.63734L5.48063 1.92469L6.81797 4.63734L9.81797 5.07469L7.64906 7.18734L8.16234 10.1686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconHeading);
export default __webpack_public_path__ + "static/media/new-icon-heading.f377b2d19c3a40183647b63bf9c78b8c.svg";
export { ForwardRef as ReactComponent };